const SDK_PROTOCOL_VERSION = 3;
function getSdkProtocolVersion() {
  return SDK_PROTOCOL_VERSION;
}
export {
  SDK_PROTOCOL_VERSION,
  getSdkProtocolVersion
};
